module.exports = __webpack_public_path__ + "static/img/A174.3040ec98.jpg";